import DOMPurify from 'dompurify';
import React from 'react';

interface IFormatHtmlTextToReactProps {
  text: string;
  style?: React.CSSProperties;
  className?: string;
}

const FormatHtmlTextToReact = ({
  text,
  style,
  className,
}: IFormatHtmlTextToReactProps) => {
  if (!text) return '';

  // 兼容老版\n,\\n换行
  const newText = text?.replace(/(\\n|\n)/g, '<br/>');

  const sanitizedContent = DOMPurify.sanitize(newText);

  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default FormatHtmlTextToReact;
